import React from 'react'
import { getCurrency } from './utilities'

const Currency = props => {
	return <span className={ props.className }>{getCurrency(props.value)}</span>
}

export default Currency